import store from '../store'
import {SET_SNACKBAR} from "@/store/mutation-types";



export const handleUnexpectedApiError = (response) => {
        store.commit(SET_SNACKBAR, {
            text: 'An unexpected error occured. If this continues, please contact<br><a href="mailto:help@healthyroster.com" style="color: white; display: block;">help@healthyroster.com</a>',
            color: 'error',
            open: true,
            isHtml: true
        });

        return {
            isSuccess: false,
            errors: [{
                code: 0,
                message: 'An unexpected error occured. If this continues, please contact help@healthyroster.com'
            }]
        }

}

export const handleExpectedApiError = (response) => {
        store.commit(SET_SNACKBAR, {
            text: response.errors[0].message,
            color: 'error',
            open: true
        });
        
        return {
            isSuccess: false,
            errors: response.errors
        }
}